import { getApiErrorCode, getApiErrorField } from '../../api/apiError'

/**
 * Talep **onayı** doğrulama hatasını (400 `VALIDATION_ERROR`) açıklayan i18n anahtarına eşler; doğrulama
 * hatası değilse `null` döner (merkezî bildirime bırakılır).
 *
 * <p>Özel durumlar ({@code DeadlineUpdateRequestService.approve}):
 *
 * <ul>
 *   <li>{@code approvedDeadline} — onaylanan tarih bugünden önce. Tipik yol: talep uzun süre beklemiş,
 *       pop-up talep edilen (artık geçmişte kalmış) tarihle dolu açılmış ve olduğu gibi onaylanmış.
 *       Takvim geçmişi seçtirmez ama ön-dolu değer bu kısıttan geçmez.
 *   <li>{@code deadlineAfterParent} — alt görevin tarihi ana görevinkinden ileri.
 * </ul>
 */
export function approveErrorKey(err: unknown): string | null {
  if (getApiErrorCode(err) !== 'VALIDATION_ERROR') return null
  switch (getApiErrorField(err)) {
    case 'approvedDeadline':
      return 'deadlineRequests.approve.errors.pastDate'
    case 'deadlineAfterParent':
      return 'deadlineRequests.approve.errors.afterParent'
    default:
      return 'common.errors.generic'
  }
}
